export default __webpack_public_path__ + "static/media/001-aim.bf59610b.svg";